import { Events } from '@axo/shared/services/analytics/Events.taxonomy';

const events: Record<string, Events> = {
  debtRegisterConsentInitiated: 'Debt Register Consent Initiated',
  debtRegisterDetailsViewed: 'Debt Register Details Viewed',
  debtRegisterFillManualToggled: 'Debt Register Fill Manual Toggled',
};

export default events;
